import React from "react";
import { Navbar, Container, Nav, Form, FormControl, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Logo from '../assets/images/logo512.png';

const MainNavbarComp = () => {
    const location = useLocation();
    return (
        <Navbar bg="light" className="fixed-top mt-30" expand="lg">
            <Container fluid>
                <Navbar.Brand as={Link} to="/">
                    <img className="nav-logo" src={Logo} alt="astudyhub organization official logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <Nav.Link as={Link} to="/#about">About</Nav.Link>
                        <Nav.Link as={Link} to="/#why-astudyhub">Why AStudyHub</Nav.Link>
                        <Nav.Link as={Link} to="/#scholarship-criteria">Scholarship Criteria</Nav.Link>
                        <Nav.Link as={Link} to="/">Event & Activities</Nav.Link>
                        <Nav.Link as={Link} to="/hindi-typing" active={location.pathname === '/hindi-typing'}>
                          Hindi Typing
                        </Nav.Link>
                        <Nav.Link as={Link} to="/grammar-fix" active={location.pathname === '/grammar-fix'}>
                          Grammar Fix
                        </Nav.Link>
                    </Nav>
                    <Form className="d-flex" onSubmit={e => e.preventDefault()}>
                        <FormControl
                            type="search"
                            placeholder="Search"
                            className="me-2"
                            aria-label="Search"
                        />
                        <Button variant="outline-success">Search</Button>
                    </Form>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}


export default MainNavbarComp;